import './App.scss'
import AppNavigation from './navigation/AppNavigation'
import { Provider } from 'react-redux'
import store from './store/store'
function App() {
  return (
    <Provider store={store}>
      <AppNavigation />
    </Provider>
  )
}

export default App
